<template>
<div class="main">
  <div class="banner" >
    <navComponent :activeName="activeName"></navComponent>
    <bookNowBanner></bookNowBanner>
  </div>
   <bookNow></bookNow>
  <footerComponent></footerComponent>
</div>
</template>

<script>
import bookNowBanner from '/components/pc/headerComponent/bookNowBanner.vue'
import footerComponent from '/components/pc/footerComponent/footerComponent.vue'
import bookNow from '/components/pc/bookNow/bookNow.vue'
import navComponent from '/components/pc/headerComponent/navComponent.vue'
export default {
  components:{
    bookNowBanner,
    footerComponent,
    bookNow,
    navComponent
  },
    data() {
      return {
          activeName: 'fifth',
          // isNavScroll:false,
      };
    },
     mounted(){
      // window.addEventListener('scroll', () => {
      //   const scrollTop = window.scrollY || document.documentElement.scrollTop;
      //   if (scrollTop > 88) {
      //     this.isNavScroll = true
      //   } else {
      //     this.isNavScroll = false
      //   }
      // });
    },
    methods: {
    }
  };
</script>

<style scoped lang="scss">
  @import '/style/pc/nav/nav.scss';
 .main {
    font-family: Inter;
    width: 100%;
    .banner {
      width: 100%;
    }
}

</style>
